import {
  fetchGetSearchStringMicrofrontend,
  IGetSearchStringMicrofrontendRequest,
  TGetSearchStringMicrofrontendResponse,
} from '../../repositories/search-string-micro-frontend/v1/get-search-string-microfrontend';
import { TApplicationContext } from '../../types/application';
import { mapManifestForConfig } from '../../utils/microfrontends';
import { candidateToSetting } from '@cian/config/shared';

const DEGRADATION_TELEMETRY_KEY = 'degradation.searchStringMicrofrontend';

export const SEARCH_STRING_MANIFEST_INFO_SETTING_KEY = 'searchStringManifestInfo';

export const fetchSearchStringManifest = async (
  { httpApi, microfrontendsRegistry, logger, telemetry, config }: TApplicationContext,
  parameters: IGetSearchStringMicrofrontendRequest,
): Promise<void> => {
  const { cookie } = parameters;
  const headers: [string, string][] = cookie ? [['Cookie', cookie]] : [];

  try {
    const {
      response: { manifest },
    }: TGetSearchStringMicrofrontendResponse = await fetchGetSearchStringMicrofrontend({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers,
        },
      },
    });

    if (!manifest) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      throw new Error('Манифест микрофронтенда поисковой строки не найден');
    }

    microfrontendsRegistry.register(manifest);

    config.injectSettings([
      candidateToSetting({
        key: SEARCH_STRING_MANIFEST_INFO_SETTING_KEY,
        value: mapManifestForConfig(manifest),
      }).unwrap(),
    ]);
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.warning(ex, { degradation: 'Получение манифеста микрофронтенда поисковой строки' });
  }
};
